"use client";

import Fieldset from "@client/components/lead-form/components/fieldset";
import type ButterCMS from "@packages/types/buttercms";
import { setUserInteractionDataAttribute } from "@shared/constants";
import { Tile } from "@ui/js/components/tiles/tile";
import { Field, useFormikContext } from "formik";

interface Props {
	heroStepInfo: ButterCMS.InfoSection.EditableHeroQuestion;
}

export default function ButterCMSEditable({ heroStepInfo }: Props) {
	const { setFieldValue } = useFormikContext();

	return (
		<Fieldset legend={heroStepInfo?.label || ""}>
			<Field type="hidden" name="butterCMSEditable" id="butter-cms-editable" />

			{heroStepInfo?.question_tiles.map((tile, index) => {
				return (
					<Tile
						{...setUserInteractionDataAttribute(
							`lead-form__butter-cms-editable__${tile.text}__${tile.value}`,
						)}
						key={index}
						iconLeft={
							<i className={`fa-solid ${tile.icon} text-lg`} aria-hidden></i>
						}
						label={tile.text}
						value={tile.value}
						onClick={() => setFieldValue("butterCMSEditable", tile.value)}
					/>
				);
			})}
		</Fieldset>
	);
}
